import { resizeImage } from '@mc/resize-image'

export const tileOptimizedImage = (src: string) =>
  resizeImage(src, {
    width: 395,
    height: 702,
    quality: 75,
    dpr: 1,
  })

export const nameplateOptimizedImage = (src: string) =>
  resizeImage(src, { width: 200, quality: 75, dpr: 2 })

export const nameplateOptimizedTrimmedImage = (src: string) => {
  let realSrc = src
  // PEN-6535
  // masterclass.com/course-images goes to the image-resize-production worker
  // but Cloudflare's resizer (cdn-cgi) throws a redirect loop when requesting the image from a worker
  // so we're bypassing the worker and using the static hostname from S3
  if (realSrc.includes('masterclass.com/course-images')) {
    realSrc = realSrc.replace(
      /(?:www\.)?masterclass\.com\/course-images\/attachments/,
      'www-static.masterclass.com/attachments',
    )
  }
  return resizeImage(realSrc, {
    width: 200,
    quality: 75,
    dpr: 2,
    trim: 'border',
  })
}
